import { BaseDomainModel } from '../models/base/base-domain-model';
import { Injectable } from '@angular/core';
import { EmployersAPI } from '../api/employers-api';
import { Observable } from 'rxjs';
import { EmployerUser } from '../models/users/dto/employer-user';
import { ODataQueryOptions } from '../models/shared/odata-query-options';
import { ODataResponse } from '../models/protocols/odata-response';
import { map } from 'rxjs/operators';
import { ChangeEmailRequest } from '../models/users/requests/change-email-request';
import { HttpResponse } from '@angular/common/http';
import { CreateMemberRequest } from '../models/users/requests/create-member-request';
import { MemberUser } from '../models/users/dto/member-user';
import { EmployerSearchResult } from '../models/shared/employer-search-result';
import { Employer } from '../models/employers/employer';
import { Mentionable } from '../models/base/mentionable';
import { IpEmployerRecordComment } from '../models/employers/ip-employer-record-comment';
import { IpEmployerRecordCommentRequest } from '../models/employers/requests/ip-employer-record-comment-request';
import { OdataUtils } from '../utils/odata-utils';

// Provided by Logged In Scope
@Injectable()
export class EmployersDomainModel extends BaseDomainModel {
  constructor(private employersAPI: EmployersAPI) {
    super();
  }

  public createEmployee(req: CreateMemberRequest): Observable<MemberUser> {
    return this.employersAPI.createEmployee(req);
  }

  public forceChangeEmail(u: EmployerUser, req: ChangeEmailRequest): Observable<EmployerUser> {
    return this.employersAPI.forceChangeEmail(u, req);
  }

  public forceChangePassword(u: EmployerUser): Observable<HttpResponse<any>> {
    return this.employersAPI.forceResetPassword(u);
  }

  public searchEmployersByIdOrName(searchString: string): Observable<EmployerSearchResult[]> {
    const queryOptions = new ODataQueryOptions();
    const searchStringIsId = !isNaN(Number(searchString));
    if (searchStringIsId) {
      queryOptions.setFilter(`id eq ${searchString}`);
    } else {
      queryOptions.setFilter(`contains(Name, '${OdataUtils.escapeFilterValue(searchString)}')`);
    }
    return this.employersAPI.searchEmployersByIdOrName(queryOptions).pipe(map(r => r.value));
  }

  public ipGetEmployers(oDataQueryOptions: ODataQueryOptions): Observable<ODataResponse<Employer>> {
    return this.employersAPI.ipGetEmployers(oDataQueryOptions);
  }

  public ipSearchEmployersById(searchString: string): Observable<EmployerSearchResult[]> {
    const queryOptions = new ODataQueryOptions();
    queryOptions.setFilter(`id eq ${searchString}`);
    return this.employersAPI.searchEmployersByIdOrName(queryOptions).pipe(map(r => r.value));
  }

  public ipSearchEmployersByName(searchString: string): Observable<EmployerSearchResult[]> {
    const queryOptions = new ODataQueryOptions();
    queryOptions.setFilter(`contains(Name, '${OdataUtils.escapeFilterValue(searchString)}')`);
    return this.employersAPI.searchEmployersByIdOrName(queryOptions).pipe(map(r => r.value));
  }

  public ipGetEmployerCommentMentionables(opts: ODataQueryOptions): Observable<Mentionable[]> {
    return this.employersAPI.ipGetEmployerCommentMentionables(opts).pipe(map(r => r.value));
  }

  public ipGetCommentsForEmployer(employerId: string): Observable<IpEmployerRecordComment[]> {
    return this.employersAPI.ipGetCommentsForEmployer(employerId).pipe(map(r => r.value));
  }

  public ipAddCommentToEmployerRecord(req: IpEmployerRecordCommentRequest): Observable<IpEmployerRecordComment[]> {
    return this.employersAPI.ipAddEmployerRecordComment(req);
  }
}
